/* -----------------------------------------------------------------------------
 * NIVO SLIDER - Ir a cierta transparencia
 * -----------------------------------------------------------------------------
 */
var nivo_pause_time = 3000;

function nivoSlideTo(item)
{
	$('#slider').data('nivo:vars').currentSlide = item - 1;

    setTimeout(function() {
    	$("#slider").find('a.nivo-nextNav').trigger('click');
    	$('#slider').data('nivoslider').start();
    	nivo_pause_time = 0;
    }, 0);

}

function setDelay() {

    var currentSlide = $('#slider').data("nivo:vars").currentSlide;

    setTimeout(function () {
        $('#slider').find('a.nivo-nextNav').click();
        nivo_pause_time = 3000;
    }, nivo_pause_time);
}

/* -----------------------------------------------------------------------------
 * ON WINDOW LOAD
 * -----------------------------------------------------------------------------
 */
// $(window).load( function() {
document.addEventListener('DOMContentLoaded', function() {
	// Menú
	$('#nav .navbar-nav > li').hoverIntent({
		interval: 20, // milliseconds delay before onMouseOver
		over: function() {
			$(this).find('.main-subnav').fadeIn(50);
			$(this).find('> a').addClass('active');
			$(this).prev().find('> a').addClass('no-bg');
		},
		timeout: 100, // milliseconds delay before onMouseOut
		out: function() {
			$(this).find('.main-subnav').fadeOut(50);
			$(this).find('> a').removeClass('active');
			$(this).prev().find('> a').removeClass('no-bg');
		}
	});

	// Nivo Slider
	$('#slider').nivoSlider({
	   	effect: 		'fade',
		directionNav: 	false,
		controlNav	: 	true,
		pauseOnHover: 	false,
		animSpeed	: 	300,
		manualAdvance: 	false,
		afterChange: function () { nivo_pause_time = 0; setDelay(); },
        afterLoad: function () { nivo_pause_time = 0; setDelay(); },
		beforeChange: function() {
			var currentSlide = jQuery('#slider').data( 'nivo:vars' ).currentSlide + 1;
			var totalSlides = jQuery('#slider').data( 'nivo:vars' ).totalSlides;

			if ( currentSlide == -1 ) currentSlide = totalSlides - 1;
			if ( currentSlide == totalSlides ) currentSlide = 0;

			$('#slider-controls span').removeClass('active');
			$('#slider-controls li:eq(' + currentSlide + ') span').addClass('active');

			$('#por-que-comprar .item').hide();
			$('#por-que-comprar .item:nth-child(' + (currentSlide + 1) + ')').fadeIn(400);
		}
	});

	$('#slider-controls span').click( function() {
		$('.nivo-controlNav').find('a.nivo-control[rel="' + $(this).closest('li').index() + '"]').click();
	});

	// Carrusel de productos
	$('.show-carousel').animate({'opacity': 1}, 200, 'linear');
	$('.show-carousel').jcarousel({
        scroll: 5
    });

    $('.show-carousel-4').jcarousel({
        visible: 4,
        scroll: 4
    });

    $('.show-carousel-1').jcarousel({
        visible:1,
        scroll:1,
        width:300
    });

    $('#por-que-comprar .well').animate({'opacity': 1, 'top': '-25px'}, 300, 'easeOutCirc');
    $('#por-que-comprar .item:nth-child(1)').fadeIn(400);

	// Tabs
	$('.nav-tabs a').click(function (e) {
		e.preventDefault();
		$(this).tab('show');
	});

	// Product Info
	// $('#product-info-shop').find('label').click( function() {
	$('body').on( 'click', '.product-info-shop label, .product-info-shop span.like-label', function() {
		$('.product-info-shop .option').removeClass('active');
		// $('#product-info-shop .option').find('input[type="radio"]').css('display', 'inline');

		$(this).closest('.option').addClass('active');
		// $(this).closest('.option').find('input[type="radio"]').css('display', 'none');
		$('#shopping-inline-add-message .content').popover('show');

		if ( $(this).closest('.option').hasClass('option-with-input') )
		{
			$(this).closest('.option').find('input[type="text"]').focus();
            $(this).closest('.option').find('input[type="radio"]').prop("checked", true);
		}

		var popover_aux = $(this).closest('.popover');
		setTimeout(function() {
			// $(popover_aux).remove();
			$(popover_aux).removeClass('in').css('display', 'none');
		}, 500);

		setTimeout(function() {
			$('#shopping-inline-add-message .content').popover('hide');
		}, 2000);
	});

	$('body').on( 'click', '.options-list label', function() {
        if ( !$($(this).closest('.option')).attr('data-no-available-option') ) {
            $('.options-list .option').removeClass('active');
    		$(this).closest('.option').addClass('active');

	    	if ( $(this).closest('.option').hasClass('option-with-input') )
		    {
			    $(this).closest('.option').find('input[type="text"]').focus();
    		}
        }
	});

	var image_thumb_dom = 0;
	$('#product-info .image .image-thumb img').click( function() {
		image_thumb_dom = $(this).index() + 1;

		$('#product-info .image .image-main a').css('display', 'none');
		$('#product-info .image .image-main a:nth-child(' + image_thumb_dom + ')').show();
	});

	$('.fancybox').fancybox();

	/*$('.product [data-toggle="popover"]').popover({
		html 	: true,
		content : $('#shopping-inline').html()
	});*/

	$('.product [data-toggle="popover"]').on('show.bs.popover', function() {
		$('.product [data-toggle="popover"]').popover('hide');
	});

	$('#shopping-inline-add-message .content').popover({
		html 	: true,
		content : $('#shopping-inline-add-cart').html(),
		placement: 'bottom'
	});

	// FAQ's
	var faq_id = '';
	$('#faqs-intro .list-style-checked a').click( function(e) {
		e.preventDefault();
		faq_id = $(this).attr('href');

		$('html, body').animate({
			scrollTop: $(faq_id).offset().top - 170
		}, 300, 'easeOutCirc');
	});

	// Comprar vino por Internet
	$('#help-internet-intro li a').click( function(e) {
		e.preventDefault();
		faq_id = $(this).attr('href');

		$('html, body').animate({
			scrollTop: $(faq_id).offset().top - 160
		}, 300, 'easeOutCirc');
	});

	// Cerrar cookies
	$('#close-cookies-alert').click( function (e) {
        e.preventDefault();
        setCookieForCookiesDisc();
	});


	// Abrir el Popup de Divisas
	if ( $('body').hasClass('popup-divisas') )
	{
		$('#modal-money').modal('show');
	}

	// Abrir el Popup de Edad
	if ( $('body').hasClass('popup-age') )
	{
		$('#modal-age').modal('show');
	}

	// Abrir el Popup de Suscríbete al Newsletter
	if ( $('body').hasClass('popup-newsletter-promo') )
	{
		$('#modal-newsletter-promo').modal('show');
	}

	// Tooltips
	$('*[rel="tooltip"]').tooltip();
    $('*[data-rel="tooltip"]').tooltip();

    // buscador del footer. Se pone aqui para que cargue después de carouseles, ya que mientras estos cargan, este se hace un "lio"
    // y crea demasiado blanco debajo
    $(document).ready( function() {
                           $('#middle-search-text').autocomplete({
                               width: 457,
                               minChars: 2,
                               serviceUrl:'/async/searchAuto?language=${curr_lang}',
                               delimiter: /(,|;)\s*/, // regex or character
                               deferRequestBy: 100, //miliseconds
                               autoSubmit:true,
                               noCache: false  //default is false, set to true to disable caching
                           });
                        });

    if($('#comentarios_publicados_como').length > 0){
        var comentarios_publicados_como = $('#comentarios_publicados_como').text();
        if (comentarios_publicados_como == ''){
            $('.tooltip-msg').css('pointer-events', 'none');
            $('.tooltip-msg').css('cursor', 'default');
            $('.toggle-guia-redaccion').css('pointer-events', 'none');
            $('.toggle-guia-redaccion').css('cursor', 'default');
            $('.borrar-text-area').css('pointer-events', 'none');
            $('.borrar-text-area').css('cursor', 'default');
        }
    }

    //Puesto en general para evitar conflicto con mobile
    if($('#novedades').length > 0){
        $("#novedades").load("/" + window.curr_lang + "/portletNovedades", function(){});
    }

    // Patched model bootstrap data-api to support dynamic remote modals

    $('[data-toggle="modal"]').click(function(ev) {
      var $this   = $(this)
      var href    = $this.attr('href')
      var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) //strip for ie7
      var option  = $target.data('modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())

  //     console.log("loaded", href)
      ev.preventDefault();
      // At the moment we just ported modal-denominaciones and modal-paises from main template
      if((href.indexOf("modal-denominaciones") !== -1
        || href.indexOf("modal-uvas-") !== -1
				|| href.indexOf("modal-paises") !== -1) && !href.endsWith("tab")) {
        $('body').addClass('modal-open');
        var url = url_from_href(href);
        $('#modalplaceholder').load(url, function () {
          $('#modalplaceholder .modal').modal('show');
        });
        return;
      }

       $target
        .modal(option, this)
        .one('hide', function () {
          $this.is(':visible') && $this.focus()
        })

		})

});


if (!String.prototype.endsWith) {
  String.prototype.endsWith = function(searchString, position) {
      var subjectString = this.toString();
      if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
        position = subjectString.length;
      }
      position -= searchString.length;
      var lastIndex = subjectString.indexOf(searchString, position);
      return lastIndex !== -1 && lastIndex === position;
  };
}


function url_from_href(href) {
  var tipo = "", prod = "", tipo_prod="vi";
  if( href.indexOf("denominaciones")!== -1 ) tipo = "do";
  if( href.indexOf("paises")!== -1 ) tipo = "pa";
  if( href.indexOf("uvas") !== -1) tipo="uva";
  var p = href.split("-");
  prod = p[2];
  if (prod === "de") {
    tipo_prod="de";
  }
  url = portal_url + '/portlets/listado_all_paises_dos?tipo_prod='
    + tipo_prod +'&tipo_vino='+ prod +'&tipo_info=' + tipo;
  return url;
}



$(document).click(function(event) {

	if ( $('table.product').length > 0 ){
		if ( !$(event.target).hasClass('icon-shopping-cart') && !$(event.target).closest('p').hasClass('option') ){
			$('.popover').each( function() {
				if ( $(this).css('display') == 'block' ){
					$(this).removeClass('in').css('display', 'none');
				}
			});
			// $('.product [data-toggle="popover"]').popover('hide');
		}
	}

});

/* -----------------------------------------------------------------------------
 * ON SCROLL
 * Anclar la cabecera arriba
 * -----------------------------------------------------------------------------
 */
var bloquear = 0;

$(window).scroll(function(e) {

	/*
	if ( $('#header').hasClass('navbar-fixed-top') )
	{
	    if ( $(window).scrollTop() > 200 )
		{
			if ( bloquear == 0 )
			{
				bloquear = 1;
				console.log('off');
				// Hago scroll mucho más allá del alto de la cabecera, reduzco cabecera
				$('#header-language').fadeOut(100);
				$('#logo').animate({ 'margin-top' : '10px', 'margin-bottom' : '10px' }, 200);
				$('#logo a').css('background-image', 'url("global/styles/images/vinissimus-logo-es-mini.png")');
				$('#header-search').animate({ 'margin-top' : '20px' }, 200);
				$('#nav').css('font-size', '15px');
				$('#nav .navbar-nav > li > a').animate({ 'padding' : '8px 25px' }, 200);
				$('#page').css('padding-top', '106px');
				$('.main-subnav').css('top', '36px');
			}
		}
		else
		{
			if ( bloquear == 1 )
			{	bloquear = 0;
				// ON
				console.log('on');
				$('#header-language').fadeIn(100);
				$('#logo').animate({ 'margin-top' : '30px', 'margin-bottom' : '22px' }, 200);
				$('#logo a').css('background-image', 'url("global/styles/images/vinissimus-logo-es.png")');
				$('#header-search').animate({ 'margin-top' : '50px' }, 200);
				$('#nav').css('font-size', '18px');
				$('#nav .navbar-nav > li > a').animate({ 'padding' : '13px 25px' }, 200, function() {

				});
				$('#page').animate({'padding-top': '148px'}, 300);
				$('.main-subnav').css('top', '46px');

			}
		}
	}
	*/

	// Para colocar fijo el mensaje de "Producto añadido" del listado
	if ( $(window).scrollTop() > 200 )
	{
		if ( bloquear == 0 )
		{
			bloquear = 1;
			// OFF
			$('#shopping-inline-add-message').addClass('shopping-inline-add-message-fixed');
		}
	}
	else
	{
		if ( bloquear == 1 )
		{
			bloquear = 0;
			// ON
			$('#shopping-inline-add-message').removeClass('shopping-inline-add-message-fixed');
		}
	}

});


//Flexslider. Puesto aquí porque si se pone en extras da conflicto con mobile
    $('.flexslider').flexslider({
        animation: "slide"
    });
